import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class Swal2Service {

  constructor() { }

  showToast(title?: string, icon?: any) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      /*onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      }*/
    });

    Toast.fire({
      icon: icon,
      title: title
    })
  }

  showAlert(title?: string, icon?: any) {
    Swal.fire({
      text: title,
      icon: icon,
      heightAuto: false
    });
  }

  showTitleAlert(title?: string, text?: string, icon?: any) {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      heightAuto: false
    });
  }

  showErrorAlert(message: string) {
    Swal.fire({
      title: 'Error',
      text: message,
      icon: 'error',
      heightAuto: false
    })
  }

  deleteItem() {
    return new Promise(resolve => {
      Swal.fire({
        title: '¿Está seguro que desea borrar el siguiente registro?',
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar',
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          resolve(true);
        } else {
          resolve(false);
        }
      });

    });
  }


  deleteUser() {
    return new Promise(resolve => {
      Swal.fire({
        title: '¿Está seguro que desea borrar el siguiente registro?',
        text: 'Se le Eliminara todas las campañas asignadas',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar',
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          resolve(true);
        } else {
          resolve(false);
        }
      });

    });
  }

  cancelCustomer() {
    return new Promise(resolve => {
      Swal.fire({
        title: '¿Está seguro que desea realizar la acción?',
        //text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar',
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          resolve(true);
        } else {
          resolve(false);
        }
      });

    });
  }

  desactiveItem(message) {
    return new Promise(resolve => {
      Swal.fire({
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar',
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          resolve(true);
        } else {
          resolve(false);
        }
      });

    });
  }

  loading() {
    // no sabria cerrar
  }

  alarmImage(image, text, title) {
    Swal.fire({
      title,
      text,
      imageUrl: `/assets/images/${image}`,
      imageWidth: 300,
      imageHeight: 160,
      imageAlt: 'Custom image',
      confirmButtonColor: '#f33',
      heightAuto: false
    })
  }
}
